import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { withSystem, withoutSystem } from '../../data/content';
export function BeforeAfterSection() {
  return <section aria-labelledby="compare-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-49" data-mp="1xp3h5h4nfwsp">
      <div className="mx-auto max-w-5xl" data-id="element-50" data-mp="22nohdgjwigh5">
        <SectionHeading id="compare-heading" title={<>
              Less Preparation. <Accent data-id="element-52" data-mp="1sqju1debkeyr">More Confident Teaching.</Accent>
            </>} data-id="element-51" data-mp="22qsrsvnym8g9" />

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-53" data-mp="1ezdoazkg5l3f">
          <div className="rounded-[20px] bg-brand-paper p-7 sm:p-9" data-id="element-54" data-mp="1f0yj8qaob61t">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-charcoal/55" data-id="element-55" data-mp="1jxoyjbenlxm6">
              Without a Teaching System
            </h3>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-56" data-mp="1a0at06u9qt8n">
              {withoutSystem.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal/60" data-id="element-57" data-mp="277qba42vm3cm">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-[#B5655E]" strokeWidth={2.25} aria-hidden="true" data-id="element-58" data-mp="2295cm939vrqa" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-[20px] border-2 border-brand-cta/40 bg-white p-7 shadow-[0_30px_60px_-40px_rgba(76,103,43,0.55)] sm:p-9" data-id="element-59" data-mp="2c6jso7laaei2">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-cta" data-id="element-60" data-mp="1ohgzq3l78z89">
              With Barber Instructor Ready™
            </h3>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-61" data-mp="1xakkyy236gdg">
              {withSystem.map(item => <li key={item} className="flex items-start gap-3 text-[15px] font-medium leading-snug text-brand-charcoal" data-id="element-62" data-mp="1shrg8a6mb81d">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-63" data-mp="14rf0we91m90r" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-14 text-center font-display text-[2.2rem] font-bold leading-none text-brand-charcoal sm:text-[3rem]" data-id="element-64" data-mp="2zuk056teo5r9">
          Less Prep. <Accent data-id="element-65" data-mp="39ly01fp9r7kx">More Teaching.</Accent>
        </p>
      </div>
    </section>;
}